export default "478367302082f28d.svg"